import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Icon } from 'antd'
import className from 'classnames'
import { Logo, Render } from '../../Layout'
import { api } from '../../../services'
import { roles } from '../../../constants'

export default class extends Component {
  state = {
    active: false
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleLogout = () => {
    api.auth.logout()
    window.location.reload()
  }

  handleClick = () => {
    this.setState({ active: !this.state.active })
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ active: false })
    }
  }

  render () {
    const { active } = this.state
    const { user } = this.props

    return (
      <div className='header'>
        <div className='header__container'>
          <div className='header__inner'>
            <div className='header__part'>
              <div className='header__logo'>
                <Logo width='32' />
                <div className='header__organization'>{ user.info.organization ? user.info.organization.name : 'Yessspad' }</div>
              </div>

              <Render role={roles.ORGANIZATION_ADMIN}>
                <nav className='nav header__nav'>
                  <ul className='nav__list'>
                    <li className='nav__item'>
                      <NavLink to='/admin/content' className='nav__link' activeClassName='nav__link_active'>Content</NavLink>
                    </li>
                    <li className='nav__item'>
                      <NavLink to='/admin/channels' className='nav__link' activeClassName='nav__link_active'>Channels</NavLink>
                    </li>
                    <li className='nav__item'>
                      <NavLink to='/admin/users' className='nav__link' activeClassName='nav__link_active'>User Management</NavLink>
                    </li>
                  </ul>
                </nav>
              </Render>

              <Render role={roles.GLOBAL_ADMIN}>
                <nav className='nav header__nav'>
                  <ul className='nav__list'>
                    <li className='nav__item'>
                      <NavLink to='/admin/divisions' className='nav__link' activeClassName='nav__link_active'>Divisions</NavLink>
                    </li>
                  </ul>
                </nav>
              </Render>
            </div>

            { user.info.id
              ? <div className='header__part'>
                <div className='header__profile'>
                  <div ref={this.setWrapperRef} className={className('profile', { 'profile_active': active })}>
                    <div className='profile__head' onClick={this.handleClick}>
                      <div className='profile__name'>{ user.info.fullName }</div>
                      <div className='profile__thumb'>
                        <Icon type='user' className='profile__icon' />
                      </div>
                    </div>
                    <div className='profile__dropdown'>
                      <div className='profile__item'>
                        <NavLink to='/admin/settings' className='profile__link' activeClassName='profile__link_active' onClick={this.handleClick}>Personal Settings</NavLink>
                      </div>
                      <div className='profile__item'>
                        <div className='profile__link' onClick={this.handleLogout}>Log Out</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : <nav className='nav header__nav'>
                <ul className='nav__list'>
                  <li className='nav__item'>
                    <NavLink to='/login' className='nav__link' activeClassName='nav__link_active'>Login</NavLink>
                  </li>
                </ul>
              </nav>
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Header/Header.jsx